/* ボタン */
import React, { memo } from 'react';
var ResetButton = function (_a) {
    var title = _a.title, class_name = _a.class_name, value = _a.value, handleClick = _a.handleClick;
    return (React.createElement(React.Fragment, null,
        React.createElement("span", { className: "detail-criteria-head" }, title),
        React.createElement("div", { className: "detail-form-input" },
            React.createElement("button", { className: class_name, disabled: false, onClick: handleClick }, value))));
};
export default memo(ResetButton);
